import { withSearch } from '@elastic/react-search-ui';
import DateRangeFilters from '../../../components/filter/DateRangeFilter';

function PublicationsDatePublishedFilter({ setFilter, removeFilter, filters }) {
  return (
    <DateRangeFilters
      filters={filters}
      formHint="For example, 27 3 2007"
      fromFieldId="dateFrom"
      id="date-range"
      label="Date published"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="dateTo"
    />
  );
}

export default withSearch(({ removeFilter, setFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(PublicationsDatePublishedFilter);
